'use client';
import React, { useState } from 'react';
import { useCourses } from '@/hooks/useCourses';
import CourseGrid from './CourseGrid';
import CourseFilters from './CourseFilters';
import CourseCardSkeleton from './CourseCardSkeleton';
import { Button } from '@/components/ui';
import { useAuth } from '@/contexts/AuthContext';

export default function CourseListing() {
  const { user } = useAuth();
  const { courses, categories, loading, error, retry } = useCourses();
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeSortBy, setActiveSortBy] = useState('popular');
  const [searchQuery] = useState('');

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 py-20">
        {Array.from({ length: 6 }).map((_, i) => (
          <CourseCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (error)
    return (
      <div className="text-center py-20 bg-brand-error/5 rounded-3xl border border-brand-error/20 space-y-4">
        <p className="text-brand-error font-medium">{error}</p>
        <Button onClick={retry} variant="primary">
          Retry Loading
        </Button>
      </div>
    );

  if (courses.length === 0)
    return (
      <div className="text-center py-20 bg-white rounded-3xl border border-brand-border space-y-4">
        {user ? (
          <>
            <h3 className="text-lg font-bold text-brand-text-dark">No courses yet</h3>
            <p className="text-brand-text-muted text-sm">
              You haven't been enrolled in any courses yet.
            </p>
          </>
        ) : (
          <>
            <h3 className="text-lg font-bold text-brand-text-dark">No courses available</h3>
            <p className="text-brand-text-muted text-sm">
              There are no courses to display right now.
            </p>
          </>
        )}
      </div>
    );

  return (
    <div className="space-y-8">
      <CourseFilters
        categories={categories}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        activeSortBy={activeSortBy}
        setActiveSortBy={setActiveSortBy}
      />
      <CourseGrid
        courses={courses}
        activeCategory={activeCategory}
        activeSortBy={activeSortBy}
        searchQuery={searchQuery}
      />
    </div>
  );
}
